import { useCallback, useReducer, useRef } from "react";

export function useSet<T>(values: T[]) {
  const setRef = useRef(new Set(values));
  const [, reRender] = useReducer((x) => x + 1, 0);

  const subscribers = useRef(new Set<(values: Set<T>) => void>());
  const onChange = useCallback((callback: (values: Set<T>) => void) => {
    subscribers.current.add(callback);

    return () => {
      subscribers.current.delete(callback);
    };
  }, []);
  const notify = useCallback(() => {
    subscribers.current.forEach((callback) => {
      callback(setRef.current);
    });
  }, []);

  setRef.current.add = (...args) => {
    const res = Set.prototype.add.apply(setRef.current, args);
    reRender();
    notify();

    return res;
  };

  setRef.current.clear = (...args) => {
    Set.prototype.clear.apply(setRef.current, args);
    reRender();
    notify();
  };

  setRef.current.delete = (...args) => {
    const res = Set.prototype.delete.apply(setRef.current, args);
    reRender();
    notify();

    return res;
  };

  return [setRef.current, onChange] as const;
}
